export default __webpack_public_path__ + "static/media/progress_road.6ce6f935.png";